export default "__VITE_ASSET__CztIPecG__"